import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAISalesDock } from "@/components/AISalesDock";
import { Sparkle } from "@phosphor-icons/react";

// Lightweight, catalog-driven "Recommended for you" strip. Reuses the SAME
// /ai-sales/recommendations endpoint (and therefore the same catalog logic) as the
// SI Sales engine — max 3, eligible-only, updates as CRM/customer state changes.
export function RecommendedForYou({ heading = "Recommended for you" }) {
  const { open: openAssistant } = useAISalesDock();
  const { data: recs } = useQuery({
    queryKey: ["ai-sales-recs"],
    queryFn: async () => (await api.get("/ai-sales/recommendations")).data,
    staleTime: 60000,
  });
  const items = recs?.recommended || [];
  if (items.length === 0) return null;

  return (
    <div className="rounded-3xl border border-primary/30 bg-primary/5 p-5" data-testid="recommended-for-you">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wide text-primary">
          <Sparkle size={15} weight="fill" /> {heading}
        </p>
        <button data-testid="recommended-ask-iyeneh" onClick={() => openAssistant()}
          className="flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-transform hover:scale-105">
          <Sparkle size={15} weight="fill" /> Ask iYeneh
        </button>
      </div>
      <div className="mt-4 grid gap-2 sm:grid-cols-3">
        {items.map((r) => (
          <button key={r.key} data-testid="recommended-item" onClick={() => openAssistant(r.prompt)}
            className="rounded-2xl border border-border bg-card p-3 text-left transition-colors hover:border-primary">
            <p className="text-sm font-semibold">{r.title}</p>
            <p className="mt-0.5 text-xs text-muted-foreground">{r.sub}</p>
            {r.reason && <p className="mt-1 text-[11px] font-medium text-primary/80">{r.reason}</p>}
          </button>
        ))}
      </div>
    </div>
  );
}
